import { render, staticRenderFns } from "./comp_ProductCard-CenterAlignedSq.vue?vue&type=template&id=2d529f9b&scoped=true&"
import script from "./comp_ProductCard-CenterAlignedSq.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard-CenterAlignedSq.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard-CenterAlignedSq.vue?vue&type=style&index=0&id=2d529f9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d529f9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VHover,VSpacer})
